const Card = ({children, padding = 'p-4', className = '', ...rest}) => (
  <div
    className={`flex flex-col bg-white shadow overflow-visible rounded-lg ${padding} ${className}`}
    {...rest}>
    {children}
  </div>
);

export default Card;
